module.exports = __webpack_public_path__ + "static/img/computational_sciences_bg.e5642761.jpg";